"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _semanticUiReact = require("semantic-ui-react");

var CheckoutMessage = function CheckoutMessage(_ref) {
  var type = _ref.type,
      primaryMessage = _ref.primaryMessage,
      secondaryMessage = _ref.secondaryMessage,
      _ref$tertiaryMessages = _ref.tertiaryMessages,
      tertiaryMessages = _ref$tertiaryMessages === void 0 ? [] : _ref$tertiaryMessages,
      actionName = _ref.actionName,
      actionCallback = _ref.actionCallback;
  return /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Message, {
    positive: type === 'positive',
    negative: type === 'negative'
  }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Message.Header, null, primaryMessage), /*#__PURE__*/_react["default"].createElement("p", null, secondaryMessage), !!(tertiaryMessages && tertiaryMessages.length) && /*#__PURE__*/_react["default"].createElement(_semanticUiReact.List, {
    bulleted: true
  }, tertiaryMessages.map(function (msg) {
    return /*#__PURE__*/_react["default"].createElement(_semanticUiReact.List.Item, null, msg);
  })), actionName && actionCallback && /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Button, {
    onClick: actionCallback,
    color: "red"
  }, actionName));
};

var _default = CheckoutMessage;
exports["default"] = _default;